import 
    React, 
    { 
        // useState
    } 
from 'react';
import { Provider } from "react-redux";
import { BrowserRouter } from 'react-router-dom'

import ReduxConfigureStore from './configureStore'

import { ConfigProvider } from 'antd';

/**
 * Config & Constant
 */
import * as CONFIG from '../config'
import { THEME } from '../constants'

/**
 * Pages
 */
import SSOMaintenance from './page/SSOMaintenance'

/**
 * Service Componnent
 */
import * as Auth from '../services/auth'

/**
 * Container
 */
import App from '../containers/main'

/**
 * Style
 */
import './index.css'

/**
 * Configure Store
 */
const store = ReduxConfigureStore()

const ThemedAPP = () => {
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: THEME.THEME_COLOR,
                },
            }}
        >
            <App />
        </ConfigProvider>
    )
}

const APPWapper = () => {
    switch(CONFIG.APP_INFO.APP_MAINTENANCE_MODE === 'true') {
        case true: {
            return (
                <SSOMaintenance />
            )
        } 
        case false:
        default: {
            return (
                <>
                    <Auth.AuthBackgroundTask />
                    <ThemedAPP />
                </>
            )
        }
    }
}

const ConnectedApp = () => {
    return (
        <Provider store={store}>
            <BrowserRouter 
                future={{
                   v7_startTransition: true,
                   v7_relativeSplatPath: true
                }}
            >
                {
                    APPWapper()
                }
            </BrowserRouter>
        </Provider>
    );
}

export default ConnectedApp